import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UUID } from '@macs-frontend/core/utils/uuid';
import { environment } from '../../../../../environments/environment';
import { UsersSortTypes } from '../../enums/users-sort-types.enum';
import { UserRole } from '../../models/role.model';
import { UserSorter } from '../../models/user-sorter';
import { UserStatus } from '../../models/user-status';
import { User, UserStatuses } from '../../models/user.model';

@Component({
  selector: 'md-users-list',
  templateUrl: 'users-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersListComponent {
  // @ts-expect-error
  @Input() users: User[];
  // @ts-expect-error
  @Input() roles: UserRole[];
  // @ts-expect-error
  @Input() sorter: UserSorter;
  // @ts-expect-error
  @Input() detailsLink: string;

  @Output()
  sort: EventEmitter<UsersSortTypes> = new EventEmitter<UsersSortTypes>();
  @Output() sendInvitation: EventEmitter<User> = new EventEmitter<User>();
  @Output()
  setStatus: EventEmitter<UserStatus> = new EventEmitter<UserStatus>();
  @Output() delete: EventEmitter<User> = new EventEmitter<User>();
  @Output() addRole: EventEmitter<any> = new EventEmitter<any>();

  userStatuses = UserStatuses;
  sorterTypes = UsersSortTypes;
  statusesArray = [
    UserStatuses.ALL,
    UserStatuses.ACTIVE,
    UserStatuses.DRAFT,
    UserStatuses.INACTIVE,
    UserStatuses.PENDING,
  ];
  imagesPath = environment.images_path;

  sortBy(sortType: UsersSortTypes) {
    this.sort.emit(sortType);
  }

  roleOf(user: User, role: { uuid: UUID }): boolean {
    return !!user.roleUnits?.filter(r => r.role.uuid === role.uuid)?.length;
  }

  sendUserInvitation(user: User) {
    // @ts-expect-error
    return user.roleUnits.length ? this.sendInvitation.emit(user) : null;
  }

  setUserStatus(status: UserStatuses, user: User) {
    // @ts-expect-error
    return status === this.userStatuses.ACTIVE && !user.roleUnits.length
      ? null
      : this.setStatus.emit({ user, status });
  }

  deleteUser(user: User) {
    this.delete.emit(user);
  }

  handleAddRole() {
    this.addRole.emit();
  }
}
